
export const FILTER_TYPES = {
    TEXT: 'text',
    SELECT: 'select',
    DATE: 'date',
    STATUT: 'statut'
}

export const categoryColumns = [
    { key: "code", label: "Code" },
    { key: "label", label: "Libellé" },
];

export const categoryFilterableFields = [
    {
        key: "code",
        label: "Code",
        type: FILTER_TYPES.TEXT,
        placeholder: "Filtrer par code",
    },
    {
        key: "label",
        label: "Libellé",
        type: FILTER_TYPES.TEXT,
        placeholder: "Filtrer par libellé",
    },
];

export const categoryRowActions = [
    {
        name: "edit",
        event: "edit",
        icon: "fe fe-edit text-warning",
    },
    {
        name: "delete",
        event: "delete",
        icon: "fe fe-trash text-danger ",
    },
];

export const unitColumns = [
    { key: "code", label: "Code" },
    { key: "label", label: "Libellé" },
];

export const unitFilterableFields = [
    { key: "code", label: "Code", type: FILTER_TYPES.TEXT, placeholder: "Filtrer par code" },
    { key: "label", label: "Libellé", type: FILTER_TYPES.TEXT, placeholder: "Filtrer par libellé" },
];

export const unitRowActions = [
    { name: "edit", event: "edit", icon: "fe fe-edit text-warning" },
    { name: "delete", event: "delete", icon: "fe fe-trash text-danger" },
];


export const familyColumns = [
    { key: "code", label: "Code" },
    { key: "label", label: "Libellé" },
    { key: "description", label: "Description" },
];

export const familyFilterableFields = [
    { key: "code", label: "Code", type: FILTER_TYPES.TEXT, placeholder: "Filtrer par code" },
    { key: "label", label: "Libellé", type: FILTER_TYPES.TEXT, placeholder: "Filtrer par libellé" },
    { key: "description", label: "Description", type: FILTER_TYPES.TEXT, placeholder: "Filtrer par Description" },
];

export const familyRowActions = [
    { name: "edit", event: "edit", icon: "fe fe-edit text-warning" },
    { name: "delete", event: "delete", icon: "fe fe-trash text-danger" },
];


export const productColumns = [
    { key: "image", label: "Image" },
    { key: "name", label: "Nom" },
    { key: "referencePrice", label: "Prix (€)" },
    { key: "commissionRate", label: "Commission (%)" },
    { key: "stockQuantity", label: "Stock" },
    { key: "unitCode", label: "Unité" },
    { key: "managementType", label: "Type Gestion" },
    { key: "categoryCode", label: "Catégorie" },
    { key: "familyCode", label: "Famille" },
];

export const sotckGlobalColumns = [
    { key: 'productCode', label: 'Code Produit' },
    { key: 'productName', label: 'Nom Produit' },
    { key: 'unit', label: 'Unité' },
    { key: 'currentStock', label: 'Stock Actuel' },
    { key: 'averagePrice', label: 'Prix Moyen (Valorisation)' },
    { key: 'totalValue', label: 'Valeur Totale (FCFA)' },
    { key: 'managementType', label: 'Type de Gestion' }
];

export const stockGlobalFilterableFields = [
    {
        key: 'productCode',
        label: 'Code Produit',
        type: FILTER_TYPES.TEXT,
        placeholder: 'Filtrer par code produit'
    },
    {
        key: 'productName',
        label: 'Nom Produit',
        type: FILTER_TYPES.TEXT,
        placeholder: 'Filtrer par nom'
    },
    {
        key: 'unit',
        label: 'Unité',
        type: FILTER_TYPES.TEXT,
        placeholder: 'Filtrer par unité'
    },
    {
        key: 'managementType',
        label: 'Type de gestion',
        type: FILTER_TYPES.SELECT,
        placeholder: 'Choisir un type',
        options: [
            { label: 'CUMP', value: 'CUMP' },
            { label: 'FIFO', value: 'FIFO' },
            { label: 'LIFO', value: 'LIFO' }
        ]
    }
];

export const stockGlobalRowActions = [
    {
        name: "tracking",
        event: "tracking",
        icon: "fe fe-clock text-primary"
    }
];


export const productFilterableFields = [
    { key: "name", label: "Nom", type: FILTER_TYPES.TEXT },
    { key: "categoryCode", label: "Catégorie", type: FILTER_TYPES.TEXT },
    { key: "familyCode", label: "Famille", type: FILTER_TYPES.TEXT },
    { key: "unitCode", label: "Unité", type: FILTER_TYPES.TEXT },
    { key: "managementType", label: "Type gestion", type: FILTER_TYPES.SELECT, options: [
            { text: 'Quantité', value: 'QUANTITY' },
            { text: 'Lot', value: 'LOT' },
        ]},
]

export const productRowActions = [
    { name: "edit", event: "edit", icon: "fe fe-edit text-warning" },
    { name: "delete", event: "delete", icon: "fe fe-trash text-danger" },
    {
        name: "validate",
        icon: "fe fe-check text-success",
        event: "validate"
    },
    {
        name: "reject",
        icon: "fe fe-x text-danger",
        event: "reject"
    },
    {
        name: "history",
        icon: "fe fe-clock text-secondary",
        event: "history"
    }
]

export const purchaseColumns = [
    { key: 'id', label: 'ID' },
    { key: 'reference', label: 'Référence' },
    { key: 'totalAmount', label: 'Montant Total' },
    { key: 'status', label: 'Statut' },
    { key: 'createdDate', label: 'Date de création' },
];

export const purchaseFilterableFields = [
    { key: "reference", label: "Réf", type: FILTER_TYPES.TEXT },
    { key: "createdAt", label: "Date", type: FILTER_TYPES.DATE },
]

export const purchaseRowActions = [
    { name: "edit", event: "edit", icon: "fe fe-edit text-warning" },
    { name: "delete", event: "delete", icon: "fe fe-trash text-danger" },
]

export const saleColumns = [
    { key: 'reference', label: 'Référence' },
    { key: 'totalAmount', label: 'Montant Total' },
    { key: 'sellerName', label: 'Vendeur' },
    { key: 'saleDate', label: 'Date de vente' },
];

export const saleFilterableFields = [
    { key: "reference", label: "Réf", type: FILTER_TYPES.TEXT },
    { key: "saleDate", label: "Date", type: FILTER_TYPES.DATE }
];

export const saleRowActions = [
    { name: "edit", event: "edit", icon: "fe fe-edit text-warning" },
    // { name: "history", event: "history", icon: "fe fe-clock text-secondary" },
    {
        label: 'Détails',
        icon: 'fe fe-eye',
        event: 'details',
        class: 'btn-info'
    },
];

export const adminSaleColumns = [
    { key: 'reference', label: 'Référence' },
    { key: 'totalAmount', label: 'Montant Total' },
    { key: 'sellerName', label: 'Vendeur' },
    { key: 'saleDate', label: 'Date de vente' },
    { key: 'status', label: 'Statut' }
];

export const adminSaleFilterableFields = [
    { key: "reference", label: "Réf", type: FILTER_TYPES.TEXT },
    { key: "saleDate", label: "Date", type: FILTER_TYPES.DATE }
];

export const adminSaleRowActions = [
    { name: "details", event: "details", icon: "fe fe-eye text-primary" },
    { name: "validate", event: "validate", icon: "fe fe-check text-success" },
    { name: "reject", event: "reject", icon: "fe fe-x text-danger" },
    { name: "history", event: "history", icon: "fe fe-clock text-secondary" },
    { name: "print", event: "print", icon: "'fe fe-printer text-secondary" }
];

export const journalSaleColumns = [
    { label: "Référence", key: "reference" },
    { label: "Client", key: "clientName" },
    { label: "Vendeur", key: "sellerName" },
    { label: "Type", key: "saleType" },
    { label: "Montant total", key: "totalAmount" },
    { label: "Date de vente", key: "saleDate" },
    { label: "Statut", key: "status" }
];

export const journalSaleFilterableFields = [
    { label: "Référence", key: "reference", type: "text" },
    { label: "Client", key: "clientName", type: "text" },
    { label: "Vendeur", key: "sellerName", type: "text" },
    { label: "Type", key: "saleType", type: "select", options: ["AFFILIATE", "POS"] },
    { label: "Statut", key: "status", type: "select", options: ["PENDING", "VALIDATED", "REJECTED"] },
    { label: "Date", key: "saleDate", type: "date" }
]